<div class="layout-topbar inline-flex" :style="{'background-color' :  app_base_data.main_theme_color , 'color' : 'black'}">
    <div class="hidden md:block flex-none  align-items-center justify-content-center font-bold   py-3">
        <router-link to="/home">
            <div class="flex align-items-center">
                <span><p-avatar :image="app_base_data.main_icon" shape="circle" ></p-avatar></span>
                <span class="font-bold ml-2" style="color: black;">{{app_base_data.app_name}}</span>
            </div>
        </router-link>
    </div>

    <div class="flex-none flex align-items-center justify-content-center font-bold   py-3">
        <p-button icon="pi pi-bars" severity="info" rounded outlined class=" layout-menu-button" style="color: black;" @click="toggleAppSide()" />
    </div>
    


    <div class="block md:hidden flex-none  align-items-center justify-content-center font-bold   py-3">
        <app-global-search />
    </div>



    <div class="hidden md:block flex-grow-1 align-items-center justify-content-center px-5 py-3 ">
        <div v-for="(item, index) in menu_items" :key="index" class="flex inline-flex align-items-center" >
            <app-sub-menu :menu="item"></app-sub-menu>
        </div>
    </div>

    <div class="hidden md:block flex-none  align-items-center justify-content-center font-bold mr-3  py-3">
        <app-global-search  />
    </div>

    <div class="flex-none flex align-items-center justify-content-center font-bold  py-2 ">

        <div class="flex align-items-center gap-4 mr-2">
            <app-notif-menu />
            <app-user-menu />
        </div>
    </div>
</div>
